export default {
    active: ({modals_action}) => modals_action.active,
    data: {
        welcome_package: ({modals_action}) => modals_action.data.welcome_package,
        affiliate_signup: ({modals_action}) => modals_action.data.affiliate_signup
    }
}